import store from '@state/store'

// auth related routes
const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next(
          { name: 'login' }
        )
      },
    },
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'home',
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  
]

const registersRoutes = [
  {
    
    path: '/registers',
    name: 'Register',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'exchange',
        name: 'Exchange',
        header: 'Exchange',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/exchange')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'customer',
        name: 'Customer',
        header: 'Customer',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/customer')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'identification',
        name: 'Identification',
        header: 'Identification',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/identification')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'parameters',
        name: 'Parameters',
        header: 'parameters',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/parameters')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'city',
        name: 'City',
        header: 'City',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/city')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'bank',
        name: 'Bank',
        header: 'Bank',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/bank')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'status',
        name: 'Status',
        header: 'Status',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/status')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
            {
        path: 'users',
        name: 'Users',
        header: 'Users',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/registers/users')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]
const managerRoutes = [
  {
    
    path: '/manager',
    name: 'Report',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'history_payments',
        name: 'History payments',
        header: 'History payments',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/manager/history_payments')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]


const authProtectedRoutes = [
  ...dashboardRoutes,
  ...registersRoutes,
  ...managerRoutes
]

const allRoutes = [...authRoutes, ...authProtectedRoutes]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
